import React from "react"
import {
  EmissionsIconImage,
  EmissionsDisplayForestTextContainer,
  EmissionsDisplayItemContainer,
  EmissionsDisplayForestItemImageWrapper,
  EmissionsDisplayForestItemContainer,
  EmissionsDisplayWrapper,
  ParagraphText,
} from "../../UIKit/styles"
import carIcon from "../../UIKit/icons/car-icon.svg"
import planeIcon from "../../UIKit/icons/plane-icon.svg"
import treeIcon from "../../UIKit/icons/tree-icon.svg"
import {
  C02_SEQUESTERED,
  FLIGHTS_TAKEN,
  HECTARES_OF_FOREST,
  HECTARES_OF_PINE,
  KM_DRIVEN,
} from "../../constants"
import PropTypes from "prop-types"

function EmissionsDisplay({
  kmDriven = 0,
  flights = 0,
  pineHectares = 0,
  forestHectares = 0,
}) {
  return (
    <EmissionsDisplayWrapper>
      <EmissionsDisplayItemContainer>
        <EmissionsIconImage src={carIcon} alt="Car icon" />
        <ParagraphText>
          {kmDriven} {KM_DRIVEN}
        </ParagraphText>
      </EmissionsDisplayItemContainer>

      <EmissionsDisplayItemContainer>
        <EmissionsIconImage src={planeIcon} alt="Plane icon" />
        <ParagraphText>
          {flights} {FLIGHTS_TAKEN}
        </ParagraphText>
      </EmissionsDisplayItemContainer>

      <EmissionsDisplayForestItemContainer>
        <EmissionsDisplayForestItemImageWrapper>
          <EmissionsIconImage src={treeIcon} alt="Tree icon" />
          <EmissionsDisplayForestTextContainer>
            <ParagraphText>{C02_SEQUESTERED}</ParagraphText>
            <ParagraphText>
              {pineHectares} {HECTARES_OF_PINE}
            </ParagraphText>
            <ParagraphText>
              {forestHectares} {HECTARES_OF_FOREST}
            </ParagraphText>
          </EmissionsDisplayForestTextContainer>
        </EmissionsDisplayForestItemImageWrapper>
      </EmissionsDisplayForestItemContainer>
    </EmissionsDisplayWrapper>
  )
}

EmissionsDisplay.propTypes = {
  /** Kilometers driven figure for the display */
  kmDriven: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Flights taken figure for the display */
  flights: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Hectares of pine grown figure for the display */
  pineHectares: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Hectares of planted indigenous forest figure for the display */
  forestHectares: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EmissionsDisplay
